import React, { Component } from "react";
import './index.css';

class Header extends Component {
  constructor (props) {
    super();
    this.state = {
      header: ['Select Filter Metrics', 'Select Sort Metrics', 'Select Other Preferences']
    }
  }

  render () {
    return (
      <div className="AS-header">
        <h2 className="padding-left-right-md font-color-white font-weight-bold">
          Step {[this.props.currentStep]}: {this.state.header[this.props.currentStep-1]}</h2>
      </div>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/views/PickerView/components/Header/index.js